(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 92119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18132);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48641);
/* harmony import */ var src_components_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26718);
/* harmony import */ var src_components_common__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71033);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);









const BlogPostContainer = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => __webpack_require__.e(/* import() */ 47).then(__webpack_require__.bind(__webpack_require__, 50047)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(50047)]
  }
});
const PressContainer = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => __webpack_require__.e(/* import() */ 6747).then(__webpack_require__.bind(__webpack_require__, 26747)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(26747)]
  }
});
const ReviewsContainer = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => __webpack_require__.e(/* import() */ 7166).then(__webpack_require__.bind(__webpack_require__, 7166)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(7166)]
  }
});
const SocialProofContainer = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => __webpack_require__.e(/* import() */ 5203).then(__webpack_require__.bind(__webpack_require__, 25203)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(25203)]
  }
});
const WhyCarPlannerContainer = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => __webpack_require__.e(/* import() */ 311).then(__webpack_require__.bind(__webpack_require__, 40311)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(40311)]
  }
});
const SliderContainer = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => Promise.all(/* import() */[__webpack_require__.e(2732), __webpack_require__.e(4299)]).then(__webpack_require__.bind(__webpack_require__, 4299)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(4299)]
  }
});
const BrandContainer = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => __webpack_require__.e(/* import() */ 7448).then(__webpack_require__.bind(__webpack_require__, 45365)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(45365)]
  }
});
const InfoBoxContainer = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => __webpack_require__.e(/* import() */ 957).then(__webpack_require__.bind(__webpack_require__, 10957)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(10957)]
  }
});
const HomeNltOffersContainer = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => __webpack_require__.e(/* import() */ 8221).then(__webpack_require__.bind(__webpack_require__, 28221)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(28221)]
  }
});
const HomeSellOffersContainer = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => __webpack_require__.e(/* import() */ 3336).then(__webpack_require__.bind(__webpack_require__, 83336)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(83336)]
  }
});
const ServicesSectionContainer = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(() => __webpack_require__.e(/* import() */ 5059).then(__webpack_require__.bind(__webpack_require__, 45059)), {
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(45059)]
  }
});

const Home = _ref => {
  let {
    blogData,
    pressData
  } = _ref;
  const {
    t
  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_2___default()), {
      id: "Trustpilot",
      src: "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js",
      type: "text/javascript",
      async: true,
      defer: true
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(src_components_common__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(src_components_common__WEBPACK_IMPORTED_MODULE_6__/* .LinkRel */ .M, {
      rel: "canonical",
      href: "https://www.carplanner.com/"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(SliderContainer, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
      px: {
        base: 'l',
        md: null
      },
      bgColor: "baseWhite",
      pt: "xxl6",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(HomeSellOffersContainer, {
        title: t('indexPage:sell_offers.title'),
        action: t('indexPage:sell_offers.action'),
        alt: t('indexPage:sell_offers.alt')
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
      pb: "14",
      px: {
        base: 'l',
        md: null
      },
      bgColor: "baseWhite",
      pt: "xl",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(HomeNltOffersContainer, {
        title: t('indexPage:nlt_offers.title'),
        action: t('indexPage:nlt_offers.action'),
        alt: t('indexPage:nlt_offers.alt')
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(ReviewsContainer, {
      title: t('indexPage:reviews.title')
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(ServicesSectionContainer, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(WhyCarPlannerContainer, {
      title: t('indexPage:why_cp.title')
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(InfoBoxContainer, {
      title: t('indexPage:nlt_info.title'),
      description: t('indexPage:nlt_info.description'),
      action: t('indexPage:nlt_info.action'),
      actionTitle: t('indexPage:nlt_info.actionTitle'),
      href: "noleggio-a-lungo-termine/faq"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(SocialProofContainer, {
      title: t('indexPage:social_proof.title')
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(BrandContainer, {
      title: t('indexPage:brands.title')
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(PressContainer, {
      title: t('indexPage:press.title'),
      data: pressData
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(BlogPostContainer, {
      title: t('indexPage:blog.title'),
      action: t('indexPage:blog.action'),
      alt: t('indexPage:blog.alt'),
      data: blogData
    })]
  });
};

var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Home);

/***/ }),

/***/ 26718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18132);
/* harmony import */ var src_containers_data_slider_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34755);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







const Head = _ref => {
  let {
    title
  } = _ref;
  const {
    t
  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("title", {
      children: [title || t('common:header.title'), ' ', "| CarPlanner"]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      crossOrigin: "anonymous",
      type: "font/woff2",
      href: "https://static1.carplanner.com/fonts/Montserrat-Regular.woff2",
      as: "font"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      crossOrigin: "anonymous",
      type: "font/woff2",
      href: "https://static1.carplanner.com/fonts/Montserrat-Medium.woff2",
      as: "font"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      crossOrigin: "anonymous",
      type: "font/woff2",
      href: "https://static1.carplanner.com/fonts/Montserrat-SemiBold.woff2",
      as: "font"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      as: "image",
      href: src_containers_data_slider_json__WEBPACK_IMPORTED_MODULE_4__/* .image */ .BH
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      as: "image",
      href: src_containers_data_slider_json__WEBPACK_IMPORTED_MODULE_4__/* .boxes[0].image */ .qk[0].image
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: "preload",
      as: "image",
      href: src_containers_data_slider_json__WEBPACK_IMPORTED_MODULE_4__/* .boxes[1].image */ .qk[1].image
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Head);

/***/ }),

/***/ 71033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ LinkRel; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




const isMetaTag = value => {
  if (!value || typeof value !== 'object') return false;
  const tag = value;
  const hasNameOrProperty = typeof tag.name === 'string' || typeof tag.property === 'string';
  if (!hasNameOrProperty) return false;
  const contentOk = tag.content === undefined || typeof tag.content === 'string';
  const overrideOk = tag.override === undefined || typeof tag.override === 'string';
  return contentOk && overrideOk;
};

const normalizeMeta = meta => {
  if (!meta) return [];

  if (Array.isArray(meta)) {
    return meta.filter(isMetaTag);
  }

  if (isMetaTag(meta)) {
    return [meta];
  }

  if (typeof meta === 'object') {
    return Object.values(meta).filter(isMetaTag);
  }

  return [];
};

const MetaTags = _ref => {
  let {
    meta
  } = _ref;
  const tags = normalizeMeta(meta);
  if (tags.length === 0) return null;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
    children: tags.map((tag, index) => {
      const content = tag.override && tag.override.trim() !== '' ? tag.override : tag.content ?? '';
      const key = tag.name ?? tag.property ?? `meta-${index}`;

      if (tag.name) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
          name: tag.name,
          content: content
        }, key);
      }

      if (tag.property) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
          property: tag.property,
          content: content
        }, key);
      }

      return null;
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (MetaTags);
const LinkRel = _ref2 => {
  let {
    rel,
    href,
    crossOrigin,
    type,
    as
  } = _ref2;
  let url = '';

  if (rel === 'canonical' && href.indexOf('?') >= 0) {
    // rimuove eventuali parametri querystring
    url = href.split('?')[0] ?? '';
  } else {
    url = href;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("link", {
      rel: rel,
      href: url,
      crossOrigin: crossOrigin || null,
      type: type || null,
      as: as || null
    })
  });
};

/***/ }),

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(92119);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 34755:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"TN":"Lasciati guidare verso\\nla scelta dell’auto migliore","BH":"https://static1.carplanner.com/website/assets/index-head.jpg","Oc":"CarPlanner ti propone le offerte di auto nuove più competitive\\nsul mercato sia per l’acquisto che per il Noleggio a Lungo Termine","qk":[{"image":"https://static1.carplanner.com/website/assets/noleggia-la-tua-auto-a-lungo-termine-2.png","title":"Noleggia la tua auto a lungo termine","description":"Cerchi un’alternativa all’acquisto di un’auto?","action":"Scopri di più","actionMobile":"Scopri","href":"/noleggio-a-lungo-termine","alt":"Offerte noleggio a lungo termine","target":"_self"},{"image":"https://static1.carplanner.com/website/assets/acquista-la-tua-nuova-auto-online-2.png","title":"Acquista la tua nuova auto online","description":"Cerchi la tua\\nnuova auto?","action":"Scopri di più","actionMobile":"Scopri","href":"/offerte-auto","alt":"Offerte auto in vendita","target":"_self"}],"PX":{"a":"Contattaci ora"}}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);